import { render } from "./ImpersonationBanner.vue?vue&type=template&id=e19ebea0&scoped=true"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=js"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=js"

import "./ImpersonationBanner.vue?vue&type=style&index=0&id=e19ebea0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e19ebea0"]])

export default __exports__